export default {
  ZH_HK: {
    loading: "加載中",
    add: "添加問題",
    coverTitle: "封面標題"
  },
  zh_cn: {
    loading: "加载中",
    add: "添加问题",
    coverTitle: "封面标题"
  },

  EN: {
    loading: "Loading",
    add: "Add a question",
    coverTitle: "Cover Title"
  },

  es: {
    loading: "Cargando",
    add: "Añadir pregunta",
    coverTitle: "Título de la portada"
  }
};
